/**
 * Watchlist names by id, mirrored from every `listWatchlists` response, so
 * code outside React (the change notice) can name a list without importing
 * the store. Names only, never shown as ids.
 */
const names = new Map<number, string>()

export function rememberWatchlistNames(
  lists: ReadonlyArray<{ id: number; profileName: string }>,
): void {
  for (const list of lists) names.set(list.id, list.profileName)
}

/** The list's name, or undefined when no response has named it yet. */
export function watchlistName(id: number): string | undefined {
  return names.get(id)
}
